import { render } from "./Wheel4.vue?vue&type=template&id=5b798554"
import script from "./Wheel4.vue?vue&type=script&lang=js"
export * from "./Wheel4.vue?vue&type=script&lang=js"
script.render = render

export default script